import { AppHtmlId, HtmlId } from '../enums/elementId';
import {
    Accordion,
    createAccordion,
} from '@vfde-brix/ws10/accordion';
import {
    getFootnoteHeadlineMapper,
    getFootnoteContentMapper,
    getFootnoteCmsContent,
} from '../util/components/footnoteHelper';
import { replaceAllPlaceholders } from '../util/formatter';
import { trackAccordion } from '../util/tracking';
import { setFiberProperty } from '../util/cms';
import { mountFootnoteLinks } from './footnoteLink';
import { JarvisProduct } from '@vfde-sails/avc-core';
import { createComponentById, toggleElementVisibilityById } from '@vfde-brix/ws10/core';

export enum AccordionType {
    FAQ = 'faq',
    Footnote = 'footnote',
}

export const mountAccordion = (wrapperId: HtmlId, type: AccordionType) => {
    const accordion = createComponentById(createAccordion, wrapperId, {
        onToggle: ({ stdHeadline, optOpen }) => optOpen && trackAccordion(stdHeadline, type),
    });

    setFiberProperty(wrapperId, accordion);

    return accordion;
};

export const closeAccordionItems = (accordion: Accordion) => {
    const { items } = accordion.getProperties();
    for (const item of items) {
        item.optOpen = false;
    }
    accordion.update({ items });
};

export const updateAccordionFootnote = (
    accordion: Accordion,
    tariffs: JarvisProduct[],
    selectedTariff?: JarvisProduct,
    regioCharge?: number,
    fiberAvailable?: boolean,
    fnf?: boolean,
) => {
    if (!accordion || !selectedTariff) {
        return;
    }

    const { items } = accordion.getProperties();
    const secondItem = items[1];
    const footnoteTexts = getFootnoteCmsContent();

    if (!secondItem || !footnoteTexts) {
        return;
    }

    items.forEach(item => {
        item.stdIconLeft = undefined;
    });

    // Note: Only update the second item's content, the first one is static!
    items[1] = {
        ...secondItem,
        stdHeadline: replaceAllPlaceholders(
            footnoteTexts.headline,
            getFootnoteHeadlineMapper(selectedTariff, regioCharge)
        ),
        containerAnyComponent: replaceAllPlaceholders(
            footnoteTexts.content,
            getFootnoteContentMapper(selectedTariff, tariffs, regioCharge)
        ),
    };
    accordion.update({ items });
    toggleElementVisibilityById(AppHtmlId.FNF_ACCORDION, fnf);

    mountFootnoteLinks(tariffs, fiberAvailable, undefined, fnf);
};
